import { Loads } from "~/features/loads/index.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const LoadsPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxltlShipmentBoard");

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled ? <Loads /> : <Construction />;
};
